import { Lang } from '@domain/language-negotiation';
import { Languages } from '../../../languages';

// getAvailableLangCodes = Languages :: Lang[]
export const getAvailableLangCodes = (availLangs: Languages): Lang[] =>
  Object.keys(availLangs);
